//(function () {
//    'use strict';

//    angular.module("imApp").factory("menuGrpsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
